// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --footer-bg: #f2c94c;          /* Fundal închis pentru profesionalism */
  --accent-color: #000000;      /* Movul tău pentru accente */
  --text-main: #ffffff;
  --text-muted: #000000;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.footer {
  background: var(--footer-bg);
  color: var(--text-main);
  border-top: 4px solid var(--accent-color); /* Linie de accent sus */
  margin-top: auto;
  font-family: 'Baloo 2', cursive;
}

.footer-container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer-content {
  display: grid;
  /* Repozitionare: 2 părți pentru descriere, 1 parte pentru restul */
  grid-template-columns: 2fr 1fr 1fr 1.5fr; 
  gap: 3rem;
  padding: 4rem 0 3rem;
}

/* Sectiunea Brand (Stânga) */
.footer-company {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.footer-logo img {
  width: 120px;
  filter: brightness(1.2);
  transition: var(--transition);
}

.footer-description {
  color: var(--text-muted);
  line-height: 1.7;
  font-size: 0.95rem;
  max-width: 400px;
}

/* Link-uri și Liste */
.footer-title {
  color: var(--accent-color);
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-list li {
  margin-bottom: 0.8rem;
}

.footer-list li a {
  color:black;
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
  text-shadow:
    1px 1px 0 black,
    -1px 1px 0 black,
    1px -1px 0 black,
    -1px -1px 0 black;
  margin:auto;
  line-height: 1;
  -webkit-text-decoration: dashed;
          text-decoration: dashed;
}

.footer-list li a:hover {
  transform: translateX(5px);
}

/* Sectiunea Social & Contact */
.footer-social {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.footer-social a {
  color: var(--text-main);
  background: rgba(255, 255, 255, 0.05);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  transition: var(--transition);
}

.footer-social a:hover {
  color: white;
  transform: translateY(-5px);
}

/* Contact Items */
.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin-bottom: 12px;
}

.contact-item svg {
  color: var(--accent-color);
}

/* Footer Bottom (Copyright) */
.footer-bottom {
  padding: 1.5rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-copyright {
  font-size: 0.85rem;
  font-weight: 100;
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
  text-shadow:
    1px 1px 0 black,
    -1px 1px 0 black,
    1px -1px 0 black,
    -1px -1px 0 black;
  margin:auto;
  line-height: 1;
}

.footer-legal {
  display: flex;
  gap: 2rem;
}

.footer-legal a {
  text-decoration: none;
  font-size: 0.65rem;
  font-weight: 100;
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
  text-shadow:
    1px 1px 0 black,
    -1px 1px 0 black,
    1px -1px 0 black,
    -1px -1px 0 black;
  margin:auto;
  line-height: 1;
}


/* Responsive */
@media (max-width: 1024px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
  .footer-title {
    text-align: start;
  font-size: 1.1rem;
  font-weight: 100;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  font-family: 'Baloo 2', cursive;
  color: #000000; /* galben */
  margin:10px 0px;
  line-height: 1;
}
.footer-list {
    text-align: start;
    list-style: none;
    padding: 0;
    margin: 0;
}
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: start;
  }
  
  .footer-company, .footer-images {
    align-items: start;
  }

   .footer-company, .footer-images img {
    align-items: start;
  }

  .footer-description {
    margin: 0 auto 1.5rem;
  }

  .footer-social {
    justify-content: center;
  }

  .footer-bottom-content {
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-list li a:hover {
    transform: none; /* Evităm mișcarea laterală pe mobile */
  }

  .footer-logo img {
    width: 65px;
    filter: brightness(1.2);
    transition: var(--transition);
}
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB,WAAW,wCAAwC;EACvE,uBAAuB,OAAO,6BAA6B;EAC3D,oBAAoB;EACpB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,yCAAyC,EAAE,wBAAwB;EACnE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,wCAAwC;EACxC,SAAS;EACT,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B;;;;qBAImB;EACnB,WAAW;EACX,cAAc;EACd,+BAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B;;;;qBAImB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B;;;;qBAImB;EACnB,WAAW;EACX,cAAc;AAChB;;;AAGA,eAAe;AACf;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,iBAAiB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B,eAAe;EACf,cAAc;AAChB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;GAEC;IACC,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe,EAAE,uCAAuC;EAC1D;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,6BAA6B;AACjC;AACA","sourcesContent":[":root {\n  --footer-bg: #f2c94c;          /* Fundal închis pentru profesionalism */\n  --accent-color: #000000;      /* Movul tău pentru accente */\n  --text-main: #ffffff;\n  --text-muted: #000000;\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.footer {\n  background: var(--footer-bg);\n  color: var(--text-main);\n  border-top: 4px solid var(--accent-color); /* Linie de accent sus */\n  margin-top: auto;\n  font-family: 'Baloo 2', cursive;\n}\n\n.footer-container {\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.footer-content {\n  display: grid;\n  /* Repozitionare: 2 părți pentru descriere, 1 parte pentru restul */\n  grid-template-columns: 2fr 1fr 1fr 1.5fr; \n  gap: 3rem;\n  padding: 4rem 0 3rem;\n}\n\n/* Sectiunea Brand (Stânga) */\n.footer-company {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n\n.footer-logo img {\n  width: 120px;\n  filter: brightness(1.2);\n  transition: var(--transition);\n}\n\n.footer-description {\n  color: var(--text-muted);\n  line-height: 1.7;\n  font-size: 0.95rem;\n  max-width: 400px;\n}\n\n/* Link-uri și Liste */\n.footer-title {\n  color: var(--accent-color);\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.footer-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-list li {\n  margin-bottom: 0.8rem;\n}\n\n.footer-list li a {\n  color:black;\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n  text-shadow:\n    1px 1px 0 black,\n    -1px 1px 0 black,\n    1px -1px 0 black,\n    -1px -1px 0 black;\n  margin:auto;\n  line-height: 1;\n  text-decoration: dashed;\n}\n\n.footer-list li a:hover {\n  transform: translateX(5px);\n}\n\n/* Sectiunea Social & Contact */\n.footer-social {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.footer-social a {\n  color: var(--text-main);\n  background: rgba(255, 255, 255, 0.05);\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  transition: var(--transition);\n}\n\n.footer-social a:hover {\n  color: white;\n  transform: translateY(-5px);\n}\n\n/* Contact Items */\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin-bottom: 12px;\n}\n\n.contact-item svg {\n  color: var(--accent-color);\n}\n\n/* Footer Bottom (Copyright) */\n.footer-bottom {\n  padding: 1.5rem 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.footer-bottom-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer-copyright {\n  font-size: 0.85rem;\n  font-weight: 100;\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n  text-shadow:\n    1px 1px 0 black,\n    -1px 1px 0 black,\n    1px -1px 0 black,\n    -1px -1px 0 black;\n  margin:auto;\n  line-height: 1;\n}\n\n.footer-legal {\n  display: flex;\n  gap: 2rem;\n}\n\n.footer-legal a {\n  text-decoration: none;\n  font-size: 0.65rem;\n  font-weight: 100;\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n  text-shadow:\n    1px 1px 0 black,\n    -1px 1px 0 black,\n    1px -1px 0 black,\n    -1px -1px 0 black;\n  margin:auto;\n  line-height: 1;\n}\n\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .footer-content {\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n  }\n  .footer-title {\n    text-align: start;\n  font-size: 1.1rem;\n  font-weight: 100;\n  margin-bottom: 1.5rem;\n  text-transform: uppercase;\n  font-family: 'Baloo 2', cursive;\n  color: #000000; /* galben */\n  margin:10px 0px;\n  line-height: 1;\n}\n.footer-list {\n    text-align: start;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n}\n\n@media (max-width: 768px) {\n  .footer-content {\n    grid-template-columns: 1fr;\n    text-align: start;\n  }\n  \n  .footer-company, .footer-images {\n    align-items: start;\n  }\n\n   .footer-company, .footer-images img {\n    align-items: start;\n  }\n\n  .footer-description {\n    margin: 0 auto 1.5rem;\n  }\n\n  .footer-social {\n    justify-content: center;\n  }\n\n  .footer-bottom-content {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .footer-list li a:hover {\n    transform: none; /* Evităm mișcarea laterală pe mobile */\n  }\n\n  .footer-logo img {\n    width: 65px;\n    filter: brightness(1.2);\n    transition: var(--transition);\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
